import { useState } from "react";
import { ArrowRight, Check, Lock } from "lucide-react";
import { JOB_STEPS } from "../CreateJobPage";
import { Checkbox } from "@components/ui/checkbox";

const PAYMENT_SOURCE = [
  {
    label: "COMTRACKED virtual wallet",
    desc: "Available balance £96.00",
    content: "Use £58.80 today · £37.20 remaining",
    value: 1,
    isDefault: true,
  },
  {
    label: "Visa ending 4242",
    desc: "Cyber Agency · Expires 08/29",
    content: "Charge the full order to this card",
    value: 2,
  },
];

const Step8 = ({ activeStep }) => {
  const [paymentType, setPaymentType] = useState(1);

  return (
    <>
      {/* Header */}
      <div className="flex border-b pb-3">
        <div className="flex flex-col gap-0.5 flex-1">
          <span className="text-xss font-bold text-light-black uppercase">
            Step {String(activeStep).padStart(2, "0")} /{" "}
            {JOB_STEPS[activeStep - 1]?.label}
          </span>
          <span className="font-semibold text-xl">
            {JOB_STEPS[activeStep - 1]?.title}
          </span>
          <span className="text-xss font-medium text-light-black">
            {JOB_STEPS[activeStep - 1]?.subtitle}
          </span>
        </div>
        <span className="self-end text-xss font-bold text-light-black uppercase leading-3">
          {JOB_STEPS[activeStep - 1]?.tagline}
        </span>
      </div>

      {/* Section 1 */}
      <div className="flex p-4 gap-4">
        {/* Col1 */}
        <div className="flex flex-col rounded-md overflow-hidden border flex-1 h-max">
          <div className="flex items-center justify-between px-4 bg-slate-50">
            <div className="flex flex-col justify-center h-14">
              <span className="font-bold text-xss text-light-black uppercase tracking-wider">
                Payment source
              </span>
              <span className="font-semibold text-sm">Choose how to pay</span>
            </div>

            <div className="font-bold text-xsss rounded-full uppercase bg-green-100 text-green-800 px-2 py-0.5">
              wallet available
            </div>
          </div>

          <div className="flex flex-col p-4 border-y gap-3">
            {PAYMENT_SOURCE?.map((paymentSource) => {
              return (
                <button className="flex items-center border rounded-md p-4">
                  <div></div>
                  <div className="flex flex-col items-start gap-0.5">
                    <span className="font-bold text-xs">
                      {paymentSource?.label}
                    </span>
                    <span className="text-light-black font-medium text-xss">
                      {paymentSource?.desc}
                    </span>
                    <span className="text-light-black font-medium text-xsss">
                      {paymentSource?.content}
                    </span>
                  </div>
                </button>
              );
            })}

            <span className="font-bold text-xss text-content-muted underline">
              Manage wallet and payment methods
            </span>
          </div>

          <div className="flex gap-2 bg-slate-100 p-4">
            <Lock size={19} color="gray" />
            <div className="flex flex-col">
              <span className="font-semibold text-xss">
                Wallet funds will be applied securely.
              </span>
              <span className="font-medium text-light-black text-xss">
                Refund credits in the agency wallet can be used toward this job
                post.
              </span>
            </div>
          </div>
        </div>

        {/* Col2 */}
        <div className="flex flex-col border rounded-md overflow-hidden flex-1">
          <div className="flex items-center justify-between h-14 px-4 bg-slate-50">
            <span className="font-bold text-xss text-light-black uppercase tracking-wider">
              order summary
            </span>
            <span className="font-bold text-xsss text-light-black uppercase tracking-wider">
              prototype pricing
            </span>
          </div>

          <div className="flex items-center justify-between p-4 border-y">
            <div className="flex flex-col">
              <span className="font-semibold text-sm">
                Cyber Security Analyst
              </span>
              <span className="font-medium text-xsss text-light-black">
                30-day published job post
              </span>
            </div>
            <span className="font-bold text-xs">£49.00</span>
          </div>

          <div className="flex flex-col p-4 gap-1.5">
            <div className="flex items-center justify-between">
              <span className="font-medium text-xss text-light-black">
                Job-post free
              </span>
              <span className="font-bold text-xss text-content-muted">
                £49.00
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="font-medium text-xss text-light-black">VAT</span>
              <span className="font-bold text-xss text-content-muted">
                £9.80
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="font-medium text-xss text-light-black">
                Payment source
              </span>
              <span className="font-bold text-xss text-content-muted">
                Virtual wallet
              </span>
            </div>
            <div className="flex items-center justify-between border-t pt-1.5 text-black">
              <span className="font-bold text-xs">Total due today</span>
              <span className="font-bold text-xs">£58.80</span>
            </div>
          </div>

          <div className="flex flex-col p-4 border-t">
            <div className="flex gap-3">
              <Checkbox id="payment-confirmation" />
              <label htmlFor="payment-confirmation" className="font-medium text-xss text-light-black cursor-pointer">
                I authorise COMTRACKED to apply £58.80 from the agency virtual
                wallet and publish this job post for candidates to view and
                match against.
              </label>
            </div>
            <button className="flex items-center justify-between rounded-md border bg-gray-200 font-bold text-xss text-light-black h-10 px-3 my-3">
              Pay £58.80 from wallet and publish
              <ArrowRight size={14} color="gray" />
            </button>

            <span className="font-medium text-xsss text-light-black">
              The wallet is selected automatically when its available balance
              covers the full order. Split payments are not included in this
              prototype.
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step8;
